const initialState = {
  balance: 0.00,
  billed: 0.00,
  received: 0.00,
  outstanding: 0.00,
  refunded: 0.00,
}

export default function account(state = initialState, action){
  switch (action.type) {
    case "SUCCESS_FETCH_ACCOUNT_BALANCE":
      return {
        ...state,
        ...action.payload
      }
    case "ADD_BALANCE":
      return {
        ...state,
        balance: Number(state.balance) + Number(action.payload.amount)
      }

    case "REMOVE_BALANCE":
      return {
        ...state,
        balance: Number(state.balance) - Number(action.payload.amount)
      }
    default:
      return state;
  }
} 